import http from './HttpService';

export function makePayment(data) {
    return http.post(`api/payments/v2/checkout`, data);
}

export function searchReceipt(number, fair) {
    return http.get(`api/payments/receipt?number=${number}&fair=${fair}`);
}

export function searchReference(guid) {
    return http.get(`api/payments/v2/reference?guid=${guid}`);
}

export function sendEmail(data) {
    return http.post(`api/payments/email`, data);
}